export default "__VITE_ASSET__db6ad9c4__"